export const getPolicyUrl = (country_code: string, language_code: string) =>
  `https://www.ikea.com/${country_code}/${language_code}/customer-service/privacy-policy/`

export const getTermsUrl = (country_code: string, language_code: string) => {
  const countryMarket = `${country_code.toLowerCase()}/${language_code.toLowerCase()}`
  const defaultURL = `https://www.ikea.com/${country_code}/${language_code}/customer-service/terms-conditions/terms-and-conditions-of-sale-pub7d95221d`
  const italyURL =
    'https://www.ikea.com/it/it/customer-service/terms-conditions/'
  const japanJaURL =
    'https://www.ikea.com/jp/ja/customer-service/terms-conditions/terms-conditions-pubcca178e0/'
  const japanEnURL =
    'https://www.ikea.com/jp/en/customer-service/terms-conditions/terms-conditions-pubcca178e0/'
  const denmarkURL =
    'https://www.ikea.com/dk/da/customer-service/terms-conditions/'

  switch (countryMarket) {
    case 'it/it':
      return italyURL
    case 'jp/ja':
      return japanJaURL
    case 'jp/en':
      return japanEnURL
    case 'dk/da':
      return denmarkURL
    default:
      return defaultURL
  }
}
